module.exports = __webpack_public_path__ + "img/hinanjo.d8ae98a6.png";